module.exports = __webpack_public_path__ + "static/media/Applause Gift Cards.d8140551.csv";